import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import confirmTypes from 'helpers/enums/confirmTypes'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import generalActions from 'redux/actions/generalActions'

const CONFIRM_TYPE = confirmTypes.MATCHING_PAIRS_UPLOAD_MEDIA_ERROR

const MpUploadMediaErrorConfirm = props => (
	<Confirm
		btTwo={'Okay'}
		alertMessage={props.message}
		actionButtonType={0}
		actionTwo={() => props.actions.closeConfirm(CONFIRM_TYPE)}
		closeAction={() => props.actions.closeConfirm(CONFIRM_TYPE)}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeConfirm: generalActions.closeConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MpUploadMediaErrorConfirm)
